module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0031.jpg?v=c64cb60f";